import { isRebranding } from './styles'

export const smartCut = (value: string, length: number): string =>
  value.length > length ? value.slice(0, length - 1) + '...' : value
export const capitalize = (value: string): string =>
  isRebranding()
    ? `${value[0].toUpperCase()}${value.toLowerCase().substring(1)}`
    : value
